<div id="submodule-tourneemaster" class="cw-module-card cwSubModule">
  <!-- Den Block anzeigen, wenn die Daten noch nicht geladen wurden -->
  @if (characteristicGroupId == 0) {
    <div>
      <!-- Header-->
      <div class="cw-flex-row">
        <!-- Modul-Titel -->
        <h2>Tourneemaster</h2>
      </div>
      @if (showModule) {
        <div [ngClass]="'icon-spinner icon-spin'"></div>
      }
      @if (!showModule) {
        <div>{{ 'GENERAL.TOURNEEMASTERPERMISSIONNOTICE' | translate }}</div>
      }
    </div>
  }

  <!-- Den Block anzeigen, wenn die Daten schon geladen wurden -->
  @if (characteristicGroupId > 0) {
    <div>
      <!-- Header-->
      <div class="cw-flex-row">
        <!-- Modul-Titel -->
        <h2>Tourneemaster</h2>
        <!-- Edit-Button einbinden. Dieser bezieht sich auf die Kennzeichengruppen-Komponenten -->
        <phscw-toolbar
          [componentIdentifier]="'characteristic-group' + characteristicGroupId"
          [componentConnection]="$any(group)"
          [buttonEditmode]="true"
          [buttonCancel]="true">
        </phscw-toolbar>
      </div>
      <!-- Im Expansion-Panel-Body die Kennzeichengruppen-Komponente einbinden -->
      <phscw-characteristic-group
        #group
        [loadCharacteristicsFromBackend]="false"
        [groupId]="characteristicGroupId"
        [entityId]="institutionId"
        [characteristicType]="characteristicType"
        [characteristicsData]="characteristicsData"
        [storageCharacteristics]="characteristicGroupDetails"
        [isVisible]="true">
      </phscw-characteristic-group>
    </div>
  }
</div>
